module.exports = __webpack_public_path__ + "static/media/distribution-icon.4be52c00.svg";